export default "/images/38f24be0b5e9921bc640230bc1bbacf3.avif";